import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Łączenie klas Tailwinda z rozwiązywaniem konfliktów (konwencja shadcn/ui). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
